export const ringCentralSettingsDefaultValues = {
  integrationType: 'bot',
}

export type RingCentralSettingsFormValues = {
  integrationType: 'recording' | 'bot'
}
